<template>
  <b-modal
    id="modal-success-create"
    class="modal-success-create"
    size="md"
    centered
    hide-header
    no-close-on-esc
    no-close-on-backdrop
  >
    <FormulateForm ref="formRef" v-model="formValues" class="modal-success-create">
      <div class="modal-success-create__illustration">
        <img src="@/assets/images/temp-tracking/map-pinpoint.png" />
      </div>

      <div class="modal-success-create__title">
        {{ title }}
      </div>

      <div class="modal-success-create__inputs">
        <template v-if="modalType === 'form'">
          <FormulateInput v-bind="fields[0]" class="__name" label="" />
          <div class="__container">
            <FormulateInput v-bind="fields[1]" class="__phone-number" label="">
              <template v-if="fields[1].prefix" #prefix>
                <div class="formulate-input-prefix">
                  <span>{{ fields[1].prefix }}</span>
                </div>
              </template>
            </FormulateInput>

            <McButton
              text="Kirim"
              icon="icon-outline_whatsapp"
              :disabled="isEditing || isLoading"
              @click="handleSubmit"
            />
          </div>

          <div class="__checkbox">
            <McCheckbox id="checkbox-map" v-model="isShowMap" />
            <label for="checkbox-map">Notifikasi kendaraan tiba</label>
          </div>

          <div v-if="isShowMap" class="modal-success-create__address">
            <div class="modal-success-create__text __map-text">
              Tentukan tujuan untuk perhitungan estimasi waktu tiba
            </div>
            <MapSelectPoint
              :modelValue="formValues.location"
              @update:modelValue="$set(formValues, 'location', $event)"
            />
          </div>
        </template>

        <div v-if="modalType === 'success-submit'" class="modal-success-create__text text-center">
          <span>
            Pelacakan berhasil terkirim!
            <a href="javascript: void(0);" @click="modalType = 'form'">Kirim ke kontak lain</a>
          </span>
        </div>

        <div class="modal-success-create__text text-center">{{ description }}</div>

        <McButton
          variant="secondary"
          text="Salin Tautan"
          class="modal-success-create__copy-link-btn"
          icon="icon-outline_link-2"
          @click="handleCopyLink"
        />
      </div>
    </FormulateForm>

    <template #modal-footer="{ cancel }">
      <div class="modal-success-create__footer">
        <McButton
          block
          variant="secondary"
          text="Lihat Daftar Pelacakan"
          @click="() => handleClickFooterBtn(cancel)"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McCheckbox from '@/components/McCheckbox'
import MapSelectPoint from '../MapSelectPoint'

import { createContactFields } from '../../lib/fields/create-contact-fields.js'
import { createContact as defaultFormValues } from '../../lib/constants/default-values'
import { GOOGLE_MAP_ADDRESS_TYPE } from '../../lib/constants/types'

import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    McButton,
    McCheckbox,
    MapSelectPoint,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['create:contact'],
  data() {
    return {
      isShowMap: false,
      modalType: 'default',
      formValues: { ...defaultFormValues },
    }
  },
  computed: {
    title() {
      if (this.modalType === 'default') {
        return 'Pelacakan Berhasil Dibuat'
      }

      return 'Pelacakan Berhasil Dibuat, Mulai Bagikan Sekarang!'
    },
    description() {
      if (this.modalType === 'default') {
        return 'Tautan pelacakan Anda sudah terkirim ke WhatsApp kontak penerima.'
      }

      return 'atau'
    },
    fields() {
      return createContactFields()
    },
    isEditing() {
      return !cloneDeep(this.formValues, defaultFormValues)
    },
  },
  methods: {
    SetModalType(type) {
      this.modalType = type

      this.isShowMap = false,
      this.formValues = { ...defaultFormValues }
    },

    resetState() {
      this.isShowMap = false
      this.modalType = 'default'
      this.formValues = { ...defaultFormValues }
    },

    handleSubmit() {
      if (this.$refs.formRef.hasErrors) {
        this.$refs.formRef.showErrors()
        this.$mcToast.error('Terdapat kesalahan format pada input anda')
        return
      }
      
      if (this.isShowMap && this.formValues.location === null) {
        this.$mcToast.error('Lokasi belum dipilih!')
        return
      }

      const newContact = {
        ...this.formValues,
      }

      if (
        this.isShowMap &&
        newContact.location?.type === GOOGLE_MAP_ADDRESS_TYPE &&
        !isNaN(parseFloat(newContact?.location.id))
      ) {
        delete newContact.location.id
      }

      this.$emit('create:contact', newContact)
    },

    handleCopyLink() {
      navigator.clipboard.writeText(this.link)
      this.$mcToast.success(`Tautan berhasil disalin`)
    },

    handleClickFooterBtn(closeFunc) {
      closeFunc()

      this.$router.push({ name: 'Tracking Temporary' })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-success-create {
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  &__illustration {
    display: flex;
    justify-content: center;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    .__container {
      display: flex;
      gap: 8px;
      justify-content: space-between;
      align-items: end;
    }

    .__name,
    .__phone-number {
      padding: 0;
    }

    .__phone-number {
      flex-grow: 1;
    }

    .__checkbox {
      display: flex;
      gap: 8px;
      color: $mep-color-text-400;

      label {
        color: $mep-color-text-400;
        margin: 0;
      }
    }
  }

  &__address {
    width: 100%;

    .__map-text {
      font-style: italic;
    }
  }

  &__text {
    color: $mep-color-text-300;

    a {
      color: $mep-secondary;
    }
  }

  &__copy-link-btn {
    max-width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }

  &__footer {
    width: 100%;
    padding: 0 28px;
    font-weight: 600;
  }
}
</style>
